module.exports = __webpack_public_path__ + "media/images/company/company_04_02-868394dfc8af41f1edce4b5a032ed2a3.jpg";